module.exports = __webpack_public_path__ + "static/services2-1e0d68b377e1a8bc3b21a08653b8cf8e.png";